import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function ImpersonateLanding() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const token = params.get('token');
    if (token) {
      localStorage.setItem('token', token);
      localStorage.setItem('impersonating', 'true');
      navigate('/portal', { replace: true });
      window.location.reload();
    } else {
      navigate('/login', { replace: true });
    }
  }, []);

  return null;
}
